export var AppModeEnum;
(function (AppModeEnum) {
    AppModeEnum[AppModeEnum["None"] = 0] = "None";
    AppModeEnum[AppModeEnum["CustomFields"] = 1] = "CustomFields";
    AppModeEnum[AppModeEnum["CaseTypeCodes"] = 2] = "CaseTypeCodes";
    AppModeEnum[AppModeEnum["CaseTypes"] = 3] = "CaseTypes";
    AppModeEnum[AppModeEnum["Claims"] = 4] = "Claims";
    AppModeEnum[AppModeEnum["AddressBook"] = 5] = "AddressBook";
    AppModeEnum[AppModeEnum["OfflineWorkflow"] = 6] = "OfflineWorkflow";
    AppModeEnum[AppModeEnum["OrganizationGroup"] = 7] = "OrganizationGroup";
})(AppModeEnum || (AppModeEnum = {}));
